import { useLocation } from 'react-router-dom'
import { first, last, split } from 'lodash'

const useLastPathnameSegment = () => {
  const { pathname } = useLocation()
  const url = first(split(pathname, '?'))
  return last(split(url, '/'))
}

export default useLastPathnameSegment
